import React from 'react';
import { Link } from 'react-router-dom';
import { MapPin, Phone, CheckCircle, ArrowRight } from 'lucide-react';
import StripePaymentButton from '../components/StripePaymentButton';
import './MensRecovery.css';

const MensRecovery = () => {
  const expectations = [
    'Maintain complete sobriety and abstinence from all substances',
    'Participate in recovery meetings and support activities',
    'Maintain employment or productive daily routines',
    'Follow all house guidelines and community standards',
    'Contribute to a supportive peer environment',
    'Work toward long-term stability and independence',
  ];

  return (
    <div className="recovery-page">
      <section className="page-hero">
        <div className="hero-container">
          <h1 className="page-title">Men's Recovery House</h1>
          <p className="page-subtitle">Whitehall, Pennsylvania</p>
        </div>
      </section>

      <section className="page-content">
        <div className="content-container">
          <div className="content-grid">
            <div className="main-content">
              <div className="content-section">
                <h2 className="content-heading">About the Program</h2>
                <p className="content-text">
                  ProSolve Global Solutions Men's Recovery House provides structured recovery housing for men committed to maintaining sobriety and rebuilding their lives.
                </p>
                <p className="content-text">
                  The men's recovery home offers a supportive peer environment where residents participate in recovery meetings, maintain employment or productive routines, and work toward long-term stability.
                </p>
              </div>

              {/* Photo Gallery */}
              <div className="photo-gallery-section">
                <h2 className="gallery-heading">Whitehall Location</h2>
                <div className="gallery-grid">
                  <div className="gallery-item">
                    <img 
                      src="/gallery/mens-01.jpg" 
                      alt="Men's Recovery House"
                      className="gallery-image"
                      loading="lazy"
                      width="400"
                      height="300"
                    />
                  </div>
                  <div className="gallery-item">
                    <img 
                      src="/gallery/mens-05.jpg" 
                      alt="Men's Recovery House Interior"
                      className="gallery-image"
                      loading="lazy"
                      width="400"
                      height="300"
                    />
                  </div>
                  <div className="gallery-item">
                    <img 
                      src="/gallery/mens-04.jpg" 
                      alt="Men's Recovery House Space"
                      className="gallery-image"
                      loading="lazy"
                      width="400"
                      height="300"
                    />
                  </div>
                  <div className="gallery-item">
                    <img 
                      src="/gallery/mens-03.jpg" 
                      alt="Men's Recovery House Living Area"
                      className="gallery-image"
                      loading="lazy"
                      width="400"
                      height="300"
                    />
                  </div>
                  <div className="gallery-item">
                    <img 
                      src="/gallery/mens-02.jpg" 
                      alt="Men's Recovery House Facility"
                      className="gallery-image"
                      loading="lazy"
                      width="400"
                      height="300"
                    />
                  </div>
                </div>
              </div>

              <div className="content-section">
                <h2 className="content-heading">What We Provide</h2>
                <ul className="feature-list">
                  <li className="feature-item">
                    <CheckCircle className="feature-icon" size={24} />
                    <span>DDAP licensed recovery residence</span>
                  </li>
                  <li className="feature-item">
                    <CheckCircle className="feature-icon" size={24} />
                    <span>Structured sober living environment</span>
                  </li>
                  <li className="feature-item">
                    <CheckCircle className="feature-icon" size={24} />
                    <span>Supportive peer community</span>
                  </li>
                  <li className="feature-item">
                    <CheckCircle className="feature-icon" size={24} />
                    <span>Access to recovery support activities</span>
                  </li>
                  <li className="feature-item">
                    <CheckCircle className="feature-icon" size={24} />
                    <span>Accountability and structure</span>
                  </li>
                  <li className="feature-item">
                    <CheckCircle className="feature-icon" size={24} />
                    <span>Utilities and housing maintenance</span>
                  </li>
                </ul>
              </div>

              <div className="content-section">
                <h2 className="content-heading">Resident Expectations</h2>
                <div className="expectations-grid">
                  {expectations.map((expectation, index) => (
                    <div key={index} className="expectation-card">
                      <div className="expectation-number">{index + 1}</div>
                      <p className="expectation-text">{expectation}</p>
                    </div>
                  ))}
                </div>
              </div>

              <div className="cta-section">
                <h3 className="cta-heading">Ready to Begin Your Recovery Journey?</h3>
                <div className="cta-buttons">
                  <Link to="/apply" className="btn btn-primary">
                    Apply Now
                    <ArrowRight size={20} />
                  </Link>
                </div>
              </div>
            </div>

            <aside className="sidebar">
              <div className="info-card">
                <h3 className="info-card-title">Locations</h3>
                <div className="info-item">
                  <MapPin size={20} className="info-icon" />
                  <div>
                    <p className="info-text">Whitehall, PA</p>
                  </div>
                </div>
              </div>

              <div className="info-card">
                <h3 className="info-card-title">Contact</h3>
                <div className="info-item">
                  <Phone size={20} className="info-icon" />
                  <a href="tel:570-579-7695" className="info-link">
                    570-579-7695
                  </a>
                </div>
              </div>

              <div className="info-card payment-card" id="make-a-payment">
                <h3 className="info-card-title">Make a Payment</h3>
                <p className="payment-card-text">Submit your housing payment securely online</p>
                <div className="sidebar-stripe-button">
                  <StripePaymentButton />
                </div>
              </div>

              <div className="info-card">
                <h3 className="info-card-title">Quick Links</h3>
                <div className="quick-links">
                  <Link to="/womens-recovery" className="sidebar-link">
                    Women's Recovery House
                  </Link>
                  <Link to="/testimonials" className="sidebar-link">
                    Read Testimonials
                  </Link>
                  <Link to="/contact" className="sidebar-link">
                    Contact Us
                  </Link>
                </div>
              </div>
            </aside>
          </div>
        </div>
      </section>
    </div>
  );
};

export default MensRecovery;
